import React from 'react'
import { Skeleton } from '@mui/material';

const SkeletonWorkComment = () => {
    return (
        <>
            {[...Array(6)].map((_) => (
                <Skeleton variant="rectangular" sx={{ mb: 1 }} height={100} />
            ))}
        </>
    )
}
export default SkeletonWorkComment;
